import {
  ACCOUNT_PROPERTY_GET,
  ACCOUNT_PROPERTY_DELETE,
  ACCOUNT_PROPERTY_MAP,
  ACCOUNT_PROPERTIES,
  PROPERTY_IMPORT_STATUS,
  PROPERTY_IMPORT_HISTORY,
  PROPERTY_IMPORT_COLUMNS,
  ACCOUNT_PROPERTY_IMPORT,
  PROPERTY_IMPORT_CANCEL,
  ACCOUNT_PROPERTY_RISK_CONTROL_GET,
  ACCOUNT_PROPERTY_RISK_CONTROL_DELETE
} from '../actions/properties'
import apiCall from './call'

const model = 'properties'

const state = {
  //
}

const getters = {
  //
}

const actions = {
  [ACCOUNT_PROPERTY_GET]: ({ commit, dispatch }, propertyId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'account_' + model + '/' + propertyId })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_PROPERTY_MAP]: ({ commit, dispatch }, accountId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'account_' + model + '/' + accountId + '/map' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_PROPERTIES]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: 'account_' + model + '/',
        qs: {
          'search': data.q,
          'filter__account_id': data.accountId,
          'paginate': 100
        }
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_PROPERTY_IMPORT]: ({ commit, dispatch }, propertyObj) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: 'properties/import/' + propertyObj.account_id,
        data: {
          'properties': propertyObj.properties,
          'orphan_missing': propertyObj.orphan_missing
        },
        method: 'POST'
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [PROPERTY_IMPORT_STATUS]: ({ commit, dispatch }, accountId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/import/' + accountId })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [PROPERTY_IMPORT_HISTORY]: ({ commit, dispatch }, accountId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/import/' + accountId + '/history' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [PROPERTY_IMPORT_COLUMNS]: ({ commit, dispatch }, accountId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/import/' + accountId + '/columns' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [PROPERTY_IMPORT_CANCEL]: ({ commit, dispatch }, accountId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/import/' + accountId, method: 'DELETE' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_PROPERTY_DELETE]: ({ commit, dispatch }, userId) => {
    let users = { ids: [userId] }
    return new Promise((resolve, reject) => {
      apiCall({ url: 'account_' + model, data: users, method: 'DELETE' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_PROPERTY_RISK_CONTROL_GET]: ({ commit, dispatch }, riskControlID) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'risk_control/' + riskControlID })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_PROPERTY_RISK_CONTROL_DELETE]: ({ commit, dispatch }, riskControlID) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'risk_control/' + riskControlID, method: 'DELETE' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  //
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/properties.js